import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useKeycloak } from "@react-keycloak/web";

import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { useTranslation } from "react-i18next";
import "../../Menu.css";
import { Notifications } from "../../Context/Notifications";
import MenuSectionsComponent from "./components/MenuSectionsComponent";
import UserSectionsComponent from "./components/UserSectionsComponent";
import LateralMenu from "./components/LateralMenu";
import { URL_HOME } from "../../../../Components/Routes/Location";
import NotificationMenuComponent from "./components/NotificationMenuComponent";
import { shouldHideLateralMenu } from "../../../../Utils/utils";
import { CONFIGURATION_SECTION, LOGOUT_SECTION, RANKING_SECTION, STUDIO_SECTION } from "../../MenuConstants";
import iconDiputacion from "../../../../Resources/Images/dc_negativo.png";
import default_section_icon from "../../../../Resources/Images/default_section_icon.svg";
import { ENVIRONMENT, MULTITENANT_CONSTANTS, TENANT } from "../../../../Resources/Multitenant/tenantConstants";
import { checkMuiIconService } from "../../../../services/services";
import {URL_BASE_IMAGE} from "../../../../services/servicesConstants";
import { logoutFromKeycloak } from "../../../../Utils/keycloak";
import { URL_LOGIN } from "../../../../Components/Routes/Location";
import { useHistory } from "react-router-dom";
import { isCordovaAvailable } from "../../../../Utils/secureStorageUtil";
import { saveUserDataActionCreator, userLoginActionCreator } from "../../../../actions/commonActions";
import {removeTokenFromCookie,generateCSSFilter, getSectionName } from "../../../../Utils/utils";
import {MAX_NOTIFICATIONS,DISPLAY_NOTIFICATIONS, MENU_DISPLAY_TOP } from "../../../../Utils/Constants";

const MenuComponent = ({ handleToggleNotifications, renderMobileVersion, handleChangeSection }) => {
  useEffect(() => {
    setTimeout(() => {
      const sidebarHoverColor = getComputedStyle(document.documentElement)
        .getPropertyValue("--sidebarHoverIconColor")
        .trim();


      if (sidebarHoverColor && /^#[0-9A-Fa-f]{6}$/.test(sidebarHoverColor)) {
        const cssFilter = generateCSSFilter(sidebarHoverColor); // Genera el filtro
        // Aplica el filtro como variable CSS
        document.documentElement.style.setProperty("--iconHoverFilter", cssFilter);
      } else {
        console.warn("El color no es válido o está undefined:", sidebarHoverColor);
      }
    }, 500);
  }, []);

  const DEFAULT_ICON = "play-circle-outline";

  const { t } = useTranslation();
  const { keycloak } = useKeycloak();

  const [showMenu, setShowMenu] = useState(false);
  const [displayNotifications, setDisplayNotifications] = useState(false);
  const [numberNewNotifications, setNumberNewNotifications] = useState(0);
  const iconName = useRef({});
  const [reloadIconFlag, setReloadIconFlag] = useState(false);

  const DIPUTACION = "cinfo-deputacion";

  const { notifications } = useContext(Notifications);
  const history = useHistory();
  const dispatch = useDispatch();
  const shouldNotRenderLateralMenu = shouldHideLateralMenu(history.location.pathname, renderMobileVersion);

  const { sectionsMenu, userData, menuDisplay } = useSelector((state) => state.commonState);
  // El menú top solo aplica en desktop, en móvil/tablet siempre se usa el menú lateral
  const isTopMenu = menuDisplay === MENU_DISPLAY_TOP && !renderMobileVersion;

  useEffect(() => {
    setNumberNewNotifications(getNumberNewNotifications());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notifications]);

  const changeSection = (s) => {
    setShowMenu(false);
    handleChangeSection(s);
  };

  const displayMenu = () => {
    if (showMenu) {
      setShowMenu(false);
    } else {
      setShowMenu(true);
    }
    if (displayNotifications) {
      setDisplayNotifications(false);
    }
  };

  const onContainerClick = (event) => {
    event.preventDefault();
    if (event.target === event.currentTarget) {
      setShowMenu(false);
    }
  };

  const logout = async () => {
    if (isCordovaAvailable()) {
      dispatch(userLoginActionCreator(null));
      dispatch(saveUserDataActionCreator({username: null, role: null}));
      logoutFromKeycloak();
      await removeTokenFromCookie();
      history.push(URL_LOGIN);
    } else {
      window.TiiviiPlayer?.destroyAll();
      await removeTokenFromCookie();
      await keycloak?.logout({ redirectUri: window.location.origin + URL_HOME });
    }
  };

  const handleToggleNotificationMenu = () => {
    setDisplayNotifications((displayNotifications) => !displayNotifications);

    if (showMenu) {
      setShowMenu(false);
    }
  };

  const handleCloseNotificationMenu = (event) => {
    event.preventDefault();
    if (event.target === event.currentTarget) {
      setDisplayNotifications(false);
    }
  };

  const studioUrl = MULTITENANT_CONSTANTS[TENANT]?.studioUrl[ENVIRONMENT];
  
  const userPro = "pro";
  const isUserPro = userData.role === userPro;
  const studioSection = !!studioUrl && isUserPro ? STUDIO_SECTION(studioUrl) : false;
  const configurationSection = CONFIGURATION_SECTION;
  const logOutSection = LOGOUT_SECTION;
  const rankingSection = RANKING_SECTION;

  const getNumberNewNotifications = () => {
    const newNotifications = notifications ? notifications.filter((notification) => notification.isNew) : [];
    return newNotifications.length > 0 ? newNotifications.length : 0;
  };

  const getClassName = () => {
    return numberNewNotifications > 0 ? "NotificationsContainer Signal" : "NotificationsContainer";
  };

  const checkMuiIconErrorCallback = (icon) => {
    iconName.current = { ...iconName.current, [icon]: DEFAULT_ICON };
  };

  useEffect(() => {
    setReloadIconFlag(!reloadIconFlag);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iconName.current]);

  const handleImageError = (e) => {
    e.target.src = default_section_icon;
  };



  // Helper para saber si el icono debe ser decorativo (el contenedor ya nombra la sección)
  const hasAccessibleNameFromParent = (section) => Boolean(section);

  const getIconSection = (icon, section = null) => {
    const ariaLabel = section ? getSectionName(section) : t("menu.icon.default");
    const isDecorative = hasAccessibleNameFromParent(section);

    if (icon?.data?.asset_url) {
      return isDecorative ? (
        <img
          src={`${URL_BASE_IMAGE}${icon.data.asset_url}`}
          className="CustomIcon"
          onError={handleImageError}
          alt=""
          aria-hidden="true"
          role="presentation"
        />
      ) : (
        <img
          src={`${URL_BASE_IMAGE}${icon.data.asset_url}`}
          className="CustomIcon"
          onError={handleImageError}
          alt={(icon && icon.title) || ariaLabel}
        />
      );
    } else if (typeof icon === "string" && icon.startsWith("http")) {
      return isDecorative ? (
        <img
          src={icon}
          className="CustomIcon"
          onError={handleImageError}
          alt=""
          aria-hidden="true"
          role="presentation"
        />
      ) : (
        <img
          src={icon}
          className="CustomIcon"
          onError={handleImageError}
          alt={(icon && icon.title) || ariaLabel}
        />
      );
    } else if (icon === "null") {
      return isDecorative
        ? <ion-icon name="arrow-forward-outline" aria-hidden="true" />
        : <ion-icon name="arrow-forward-outline" aria-label={ariaLabel} />;
    } else if (icon === DIPUTACION) {
      return isDecorative
        ? <img src={iconDiputacion} alt="" aria-hidden="true" role="presentation" />
        : <img src={iconDiputacion} alt={ariaLabel} />;
    } else if (!iconName.current.hasOwnProperty(icon)) {
      checkMuiIconService(icon, () => checkMuiIconErrorCallback(icon));
      return isDecorative
        ? <ion-icon name={icon} aria-hidden="true" />
        : <ion-icon name={icon} aria-label={ariaLabel} />;
    } else {
      return isDecorative
        ? <ion-icon name={iconName.current[icon]} aria-hidden="true" />
        : <ion-icon name={iconName.current[icon]} aria-label={ariaLabel} />;
    }
  };

  const [configurationIcon, setConfigurationIcon] = useState(<ion-icon name={configurationSection.section.iconId} aria-label={t(configurationSection.section.name)} />);
  const [logoutIcon, setLogoutIcon] = useState(
    <ion-icon name={logOutSection.section.iconId} className={MULTITENANT_CONSTANTS[TENANT].menuClassLogout} aria-label={t(logOutSection.section.name)} />,
  );

  useEffect(() => {
    if (configurationSection.section.imgIcon) setConfigurationIcon(configurationSection.section.imgIcon);
    if (logOutSection.section.imgIcon) setLogoutIcon(logOutSection.section.imgIcon);
  }, [configurationSection, logOutSection]);


  const renderLateralMenu = () => (
    <>
      {showMenu ? (
        <LateralMenu
          onContainerClick={onContainerClick}
          displayMenu={displayMenu}
          sections={sectionsMenu}
          rankingSection={rankingSection}
          studioSection={studioSection}
          configurationSection={configurationSection}
          logOutSection={logOutSection}
          changeSection={changeSection}
          logout={logout}
          handleToggleNotificationMenu={handleToggleNotificationMenu}
          notifications={notifications}
          getIconSection={getIconSection}
          configurationIcon={configurationIcon}
          logoutIcon={logoutIcon}
          reloadIconFlag={reloadIconFlag}
        />
      ) : (
        !shouldNotRenderLateralMenu && (
          <div className="MenuLateral">
            <div className={"MenuSection"} onClick={displayMenu}>
              <ion-icon name="menu" aria-label={t("menu.toggle")} />
            </div>
            {!!sectionsMenu.length && (
              <div className={"MenuContainer"}>
                <MenuSectionsComponent
                  sections={sectionsMenu}
                  changeSection={changeSection}
                  getIconSection={getIconSection}
                  reloadIconFlag={reloadIconFlag}
                />
                <div>
                  {!!userData.username && MULTITENANT_CONSTANTS[TENANT]?.showNotifications && (
                    <OverlayTrigger
                      delay={{ hide: 300, show: 300 }}
                      placement="top"
                      overlay={
                        <Tooltip id="tooltip-notification-bell">
                          {t("menu.notificationBellTooltip")}
                        </Tooltip>
                      }
                    >
                      <div className={getClassName()} onClick={handleToggleNotificationMenu}>
                        <div className="NotificationBellWrapper">
                          <ion-icon name="notifications" className="NotificationBell" aria-label={t("notifications")} />
                          {numberNewNotifications > 0 && (
                            <div className="NotificationDot">
                              {numberNewNotifications > MAX_NOTIFICATIONS ? DISPLAY_NOTIFICATIONS : numberNewNotifications}
                            </div>
                          )}
                        </div>
                      </div>
                    </OverlayTrigger>
                  )}
                  {!!userData.username && (
                    <UserSectionsComponent
                      studioSection={studioSection}
                      configurationSection={configurationSection}
                      logOutSection={logOutSection}
                      changeSection={changeSection}
                      logout={logout}
                      configurationIcon={configurationIcon}
                      logoutIcon={logoutIcon}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        )
      )}
    </>
  );

  return (
    <div className={`Menu ${isTopMenu ? "Menu--top" : "Menu--lateral"}`}>
      {/* En desktop con menú top, las secciones están en BarraSuperior, aquí solo ocultamos el menú lateral */}
      {!isTopMenu && renderLateralMenu()}

      {displayNotifications && MULTITENANT_CONSTANTS[TENANT]?.showNotifications && (
        <NotificationMenuComponent
          handleCloseNotificationMenu={handleCloseNotificationMenu}
          notifications={notifications}
          handleToggleNotifications={handleToggleNotifications}
          renderMobileVersion={renderMobileVersion}
        />
      )}
    </div>
  );
};

export default MenuComponent;
